import { render, staticRenderFns } from "./news-create.vue?vue&type=template&id=4470be0c&"
import script from "./news-create.vue?vue&type=script&lang=ts&"
export * from "./news-create.vue?vue&type=script&lang=ts&"
import style0 from "./news-create.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports